import { PlanType } from 'enums';
import { PlanSorter } from './PlanSorter';
import { AppStore } from 'stores/App.store';
import { AdvancedPlansProductData } from 'types';

export const useGetProducts = ({ appStore }: { appStore: AppStore }) => {
  const { advancedPlansProducts } = appStore.appContext;
  const sorter = new PlanSorter({
    isMobile: appStore.isMobile,
    isInSale: appStore.isInSale,
    experiments: appStore.experiments,
    brand: appStore.appContext.brand,
  });
  const purchasableProducts = advancedPlansProducts.filter(
    filterMobilePurchableProducts,
  );

  function filterMobilePurchableProducts(product: AdvancedPlansProductData) {
    return !appStore.isMobile || product.hasPurchasableCycles;
  }

  function filterByProductType(planType: PlanType) {
    return (product: AdvancedPlansProductData) => product.type === planType;
  }

  function getSortedProducts(products: AdvancedPlansProductData[]) {
    return sorter.sort(products);
  }

  return {
    products: getSortedProducts(purchasableProducts),
    websiteProducts: getSortedProducts(
      purchasableProducts.filter(filterByProductType(PlanType.Website)),
    ),
    businessProducts: getSortedProducts(
      purchasableProducts.filter(filterByProductType(PlanType.Business)),
    ),
  };
};
